/**
 Created by Shikha Gupta on 2021-09-15.
 */
import {Layers, OktoberfestLayers, SimpleStageLayer} from "../view/OktoberfestLayers";
import {StaticBetLine} from "./StaticBetLine";
import {StaticBetLineNumber} from "./StaticBetLineNumber";
import {Oktoberfest} from "../Oktoberfest";
import {IBetLinesConfig, OktoberfestGameConfig} from "../OktoberfestGameConfig";
import {GameHelper} from "../../core/utils/GameHelper";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {OktoberfestSymbol} from "../symbol/OktoberfestSymbol";
import {OktoberfestReelController} from "../reels/OktoberfestReelController";


interface IBetLineData {
    index: number,
    betLine: number[]
}


export class BetLinesView extends SimpleStageLayer {

    protected _betLines: StaticBetLine[];
    protected _betLineNumbers: StaticBetLineNumber[];
    protected _betLinesContainer: PIXI.Container;
    protected _betLineNumbersContainer: PIXI.Container;
    protected _resourcesLoaded: boolean = false;
    protected _reelPositionX: number;
    private _betLinesConfig: IBetLinesConfig;
    private _betLinesOrder: number[] = [4, 2, 6, 8, 1, 10, 9, 7, 3, 5, 12, 18, 20, 16, 11, 14, 15, 17, 13, 19];
    private STAGE_HEIGHT_LANDSCAPE = 720;

    private _betLinesData: IBetLineData[];
    private _parsedDataBetlines: number[][];
    private _offsetFactor: number[][];
    private _reelAreaPosition: PIXI.Point;

    constructor() {
        super();
        this.init();
    }

    public showStaticBetLine(index: number): void {
        this._betLines[index - 1].onShowStaticBetLine(index);
    }


    public hideStaticBetLine(index: number): void {
        this._betLines[index - 1].onHideStaticBetLine(index);
    }

    public onShowWinBetLine(index: number): void {
        this._betLines[index - 1].onShowWinBetLine(index);
        this._betLineNumbers[index - 1].onShowWinBetLine(index);
    }

    public onHideWinBetLine(index: number): void {
        this._betLines[index - 1].onHideWinBetLine(index);
        this._betLineNumbers[index - 1].onHideWinBetLine(index);
    }

    public onHideAllBetLines(): void {
        this._betLines.forEach((betline, index) => {
            this._betLines[index].onHideAllBetLines();
        });
        this._betLineNumbers.forEach((betline, index) => {
            this._betLineNumbers[index].onHideAllBetLines();
        });

    }

    public enableBetlineNumber(value: boolean) {
        this._betLineNumbers.forEach((betLineNumber, index) => {
            betLineNumber.setEnabled(value)
        });
        this._betLineNumbersContainer.alpha = value ? 1 : 0;
    }

    protected init(): void {
        this._betLines = [];
        this._betLineNumbers = [];
        this._betLineNumbersContainer = new PIXI.Container();
        OktoberfestLayers.getLayer(Layers.BETLINES)?.addChild(this._betLineNumbersContainer);
        this._betLinesContainer = new PIXI.Container();
        OktoberfestLayers.getLayer(Layers.BETLINES)?.addChild(this._betLinesContainer);
        this.onInitDataParsed();
        this.initBetLinePositions(new PIXI.Point(-23, 100));
    }

    protected draw(betLinesData: IBetLineData[], offsetFactor: number[][]): void {
        let symbolWidth: number = OktoberfestGameConfig.SYM_WIDTH;
        let symbolHeight: number = OktoberfestGameConfig.SYM_HEIGHT;
        this._betLinesConfig = OktoberfestGameConfig.BET_LINES;
        let betLineIndex: number;
        let linePositions: number[][];
        let betLineNumberPosition: number[];

        for (let i: number = 0; i < this._betLinesOrder.length; i++) {
            betLineIndex = this._betLinesOrder[i] - 1;
            linePositions = [];
            betLineNumberPosition = this.getBetLineNumberPosition(i);

            // number on the left, use it's position to start.
            if (betLineNumberPosition[2] === 0) {
                linePositions.push(betLineNumberPosition);
            }
            for (let j: number = 0; j < betLinesData[betLineIndex].betLine.length; j++) {
                let symId: number = betLinesData[betLineIndex].betLine[j];

                let symbol: OktoberfestSymbol = Oktoberfest.reels[0].getSymbol(symId);
                let basePosition: number[] = [( OktoberfestGameConfig.SYM_WIDTH * j ) + 10, symbol.position.y];
                basePosition[0] += this._reelPositionX + 10;
                basePosition[0] += symbolWidth / 3;
                if((betLineNumberPosition[2] === 0)){
                    basePosition[0]-=20;
                }
                if (j > 0 && symId === betLinesData[betLineIndex].betLine[j - 1]) {
                    // if the current point is in the same level as the previous one, use the same y position.
                    basePosition[1] = linePositions[linePositions.length - 1][1];
                } else {
                    basePosition[1] += symbolHeight / 2 + offsetFactor[j][symId] * this._betLinesConfig.linePointVerticalSpace+10;
                    basePosition[1] += 30;
                }
                offsetFactor[j][symId] += 1;
                linePositions.push(basePosition);

            }

            // number on the right, use it's position to end
            if (betLineNumberPosition[2] === 1) {
                linePositions.push(betLineNumberPosition);
            }
            let betLineNumber: StaticBetLineNumber = new StaticBetLineNumber(betLineNumberPosition, this._betLinesOrder[i], this._resourcesLoaded);
            this._betLineNumbersContainer.addChild(betLineNumber);
            this._betLineNumbers.push(betLineNumber);

            let betLine: StaticBetLine = new StaticBetLine(linePositions, this._betLinesOrder[i]);
            betLine.alpha = 0;
            if(betLineNumberPosition[2] === 0) {
                betLine.position.x = 30;
            }
            this._betLinesContainer.addChild(betLine);
            this._betLines.push(betLine);
        }

        this._betLines.sort((a: StaticBetLine, b: StaticBetLine) => {
            return a.index - b.index;
        });

        this._betLineNumbers.sort((a: StaticBetLineNumber, b: StaticBetLineNumber) => {
            return a.index - b.index;
        });
    }

    // Hardcoded default 20 betLines. positionIndex = 0-19
    protected getBetLineNumberPosition(positionIndex: number): number[] {
        let stageHeight: number = this.STAGE_HEIGHT_LANDSCAPE;
        let numberLeftPositionX: number = -20;
        let numberRightPositionX: number = 800;
        let numberVerticalSpace: number = ( stageHeight - ( 2 * this._betLinesConfig.numberVerticalPadding ) ) / ( ( this._parsedDataBetlines.length / 2 ) - 1 );

        // left = 0; right = 1
        let side: number = Math.floor(positionIndex / 10);
        return [side === 0 ? numberLeftPositionX : numberRightPositionX,
            Math.round(positionIndex % 10 * numberVerticalSpace + this._betLinesConfig.numberVerticalPadding),
            side
        ];
    }

    private initBetLinePositions(position: PIXI.Point): void {
        const scale: number = 1;
        this._reelAreaPosition = position;
        this._betLineNumbersContainer.position.y = position.y - ( OktoberfestGameConfig.FREESPIN_INTRO_BACKGROUND_OFFSET * scale );
        this._betLineNumbersContainer.position.x = position.x;
        this._betLinesContainer.position.y = position.y - ( OktoberfestGameConfig.FREESPIN_INTRO_BACKGROUND_OFFSET * scale );
        this._betLinesContainer.position.x = position.x-20;
        this._reelPositionX = 0;
        this._betLinesContainer.removeChildren();
        this._betLineNumbersContainer.removeChildren();
        this._offsetFactor = this.calculateOffset();
        this.draw(this._betLinesData, this._offsetFactor);
    }

    private onInitDataParsed(): void {
        this._parsedDataBetlines = Oktoberfest.model.parsedInitData.betLines;
        let betLinesData: IBetLineData[] = [];

        for (let i: number = 0; i < this._parsedDataBetlines.length; i++) {
            betLinesData.push({
                index: i + 1,
                betLine: this._parsedDataBetlines[i].concat()
            })
        }

        this._betLinesData = betLinesData;
        this._offsetFactor = this.calculateOffset();
    }

    private calculateOffset(): number[][] {
        // init offsetFactor.
        let offsetFactor: number[][] = [];
        for (let i: number = 0; i < OktoberfestGameConfig.REELS_NUM; i++) {
            let reel: number[] = [];
            for (let j: number = 0; j < OktoberfestGameConfig.SYM_NUM_IN_REEL; j++) {
                reel.push(0.5);
            }
            offsetFactor.push(reel);
        }

        for (let i: number = 0; i < this._parsedDataBetlines.length; i++) {
            for (let j: number = 0; j < this._parsedDataBetlines[i].length; j++) {
                // the offsetFactor is to offset the points so the lines go through the same symbol don't overlap
                // with the same point.
                offsetFactor[j][this._parsedDataBetlines[i][j]] -= 0.2;
            }
        }

        return offsetFactor;
    }
}


